export default __webpack_public_path__ + "static/media/wordpress.20c8eb57.png";